<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title class="d-flex align-items-end w-100 justify-content-between">
          Elimizdeki Çekler Raporu
          <b-card-sub-title
            class="font-medium-2 badge badge-light-success badge-pill px-1"
          >
            {{ moment(filterParams.edate).format('DD.MM.YYYY') }}
          </b-card-sub-title>
        </b-card-title>
      </b-card-header>
      <b-table-simple
        responsive
        striped
        bordered
        class="mb-0"
      >
        <b-thead>
          <b-tr>
            <b-th>
              Tanım
            </b-th>
            <b-th class="width-200 text-nowrap text-right">
              Vade Tarihi
            </b-th>
            <b-th class="width-200 text-nowrap text-right">
              Tutar
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template
            v-for="(item,index) in promissories.data"
          >
            <b-tr :key="index">
              <b-td>
                {{ item.title }}
                <div class="text-muted font-small-3">
                  {{ item.notes }}
                </div>
              </b-td>
              <b-td class="text-right">
                {{ moment(item.expiry_date).format('DD.MM.YYYY') }}
              </b-td>
              <b-td class="text-right">
                {{ item.amount | toCurrency }} TL
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-th colspan="2">
              Genel Toplam
            </b-th>
            <b-th class="text-right">
              {{ promissories.grandTotal | toCurrency }} TL
            </b-th>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTableSimple, BThead, BTbody, BTh, BTd, BTr, BTfoot, BCardHeader, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'PromissoriesReport',
  components: {
    BCard,
    BTableSimple,
    BThead,
    BTbody,
    BTfoot,
    BTh,
    BTd,
    BTr,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
  },
  computed: {
    moment() {
      return moment
    },
    month() {
      return this.$store.getters['directorReports/month']
    },
    filterParams() {
      return this.$store.getters['directorReports/filterParams']
    },
    promissories() {
      return this.$store.getters['directorReports/promissories']
    },
  },
}
</script>
